import { useMutation } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { checkDomainAvailability, suggestDomains } from './endpoints';
import { availableDomainAtom, domainSuggestionsAtom } from '../atoms';
import type { CheckDomainAvailabilityResponse } from '@wix/ambassador-premium-domains-v2-availability/types';

export function useCheckDomainAvailability() {
  const setAvailableDomain = useSetAtom(availableDomainAtom);

  return useMutation<CheckDomainAvailabilityResponse, Error, string>({
    mutationFn: (domain: string) => checkDomainAvailability(domain),
    onSuccess: (response) => {
      if (response?.availability?.available && response.availability.domain) {
        setAvailableDomain(response.availability.domain);
      }
    },
  });
}

export function useLoadDomainSuggestions() {
  const setAvailableDomain = useSetAtom(availableDomainAtom);
  const setSuggestions = useSetAtom(domainSuggestionsAtom);

  return useMutation<string[], Error, string>({
    mutationFn: (query: string) => suggestDomains(query),
    onSuccess: (suggestions) => {
      setAvailableDomain(suggestions[0] || '');
      setSuggestions(suggestions);
    },
  });
}
